import { Box, useBreakpointValue } from '@chakra-ui/react';
import {
  CardCarouselButton,
  CarouselContent,
  Grid,
  useCarousel,
} from '@time-line/components/common';
import type { WallOfLove as WallOfLoveProps } from 'types/cms/blocks/WallOfLove';

import { CONTAINER_HEIGHT, INFO_BOX_HEIGHT } from '.';
import { Review } from './Review';
import { SocialMedia } from './SocialMedia';

export function WallOfLoveCarousel({ items }: Pick<WallOfLoveProps, 'items'>) {
  const { showControls } = useCarousel();

  const spaceBetween = useBreakpointValue(
    {
      base: 12,
      md: 24,
    },
    { fallback: 'md' },
  );
  const isCentered = useBreakpointValue(
    {
      base: true,
      md: false,
    },
    { fallback: 'md' },
  );

  return (
    <Grid
      mt={0}
      mb={`-${INFO_BOX_HEIGHT}px`}
      position="relative"
      alignItems="center"
      gridColumn="full"
      maxW="100%"
      overflow="hidden"
      borderRadius="base"
      _hover={{
        'button:not([disabled])': {
          opacity: 1,
        },
      }}
      sx={{
        '.swiper-horizontal': {
          overflow: 'visible',
          display: 'grid',
          gridTemplateColumns: 'subgrid',
          gridColumn: 'full',
          width: '100%',
        },
        '.swiper-slide': {
          width: 'auto',
        },
      }}
    >
      <CarouselContent
        slidesPerView="auto"
        centeredSlides={isCentered}
        centerInsufficientSlides
        initialSlide={Math.floor(items.length / 2)}
        spaceBetween={spaceBetween}
        loop
      >
        {items.map((item: WallOfLoveProps['items'][0]) => {
          switch (item._type) {
            case 'timeline_socialMediaStory':
              return (
                <SocialMedia
                  key={item._key}
                  handle={item.handle}
                  url={item.url}
                  video={item.video}
                  product={item.product}
                  poster={item.poster}
                  height={CONTAINER_HEIGHT + INFO_BOX_HEIGHT}
                  infoBoxHeight={INFO_BOX_HEIGHT}
                />
              );
            case 'timeline_featuredReview':
              return (
                <Review
                  key={item._key}
                  review={item}
                  height={CONTAINER_HEIGHT}
                />
              );
            default: {
              return null;
            }
          }
        })}
      </CarouselContent>
      {showControls && (
        <Box gridColumn="main" position="absolute" height="100%" width="100%">
          <CardCarouselButton direction="prev" zIndex={1} />
          <CardCarouselButton direction="next" zIndex={1} />
        </Box>
      )}
    </Grid>
  );
}
